import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  bcSpaced: {
    display: "flex",
    alignItems: "center",
    minHeight: 36,
  },
  title: {
    fontSize: "2rem",
    lineHeight: "48px",
    marginBottom: 20,
  }
}));

export default useStyles;